import React, { useState } from "react";
import Validator from "../../services/Validator";
import { Button, Card, Col, FloatingLabel, Form, Row, Spinner } from "react-bootstrap";
import Api from "../../services/ApiService";
import { MdOutlineLockPerson, MdDone } from "react-icons/md";
import IconContentCard from "./IconContentCard";
import { useNavigate } from "react-router-dom";

/**
 * PassFormComponent
 *
 * form for setting new password, will be shown if the password token was valid
 *
 * @returns msg
 */
const PassFormComponent = (props) => {

    const API = new Api(); // API
    const navigate = useNavigate();
    const VALIDATOR = new Validator(); // field validation
    const [validated, setValidated] = useState(false);
    const [errors, setErrors] = useState();

    const [pass1, setPass1] = useState(""); // field pass1
    const [pass2, setPass2] = useState(""); // field pass2
    const [isLoading, setIsLoading] = useState(false);
    const [isPassChanged, setIsPassChanged] = useState(false);
    let qr_code = localStorage.getItem("qr") || null;

    // Button "Password Zürucksetzen" handler
    const passChangeHandler = (e) => {
        e.preventDefault();
        setIsLoading(true);
        const allErrors = {};

        if (!VALIDATOR.PasswordValid(pass1))
            allErrors.pass1 =
                "Ihr Passwort muss aus mindestens 10 Zeichen (bis zu 32) bestehen und mindestens eine Ziffer und einen Buchstaben enthalten.";
        if (!VALIDATOR.PasswordsEquals(pass1, pass2))
            allErrors.pass2 =
                "Passwort muss zwei Mal gleich eingegeben werden.";
        if (!VALIDATOR.isDictEmpty(allErrors)) {
            setErrors(allErrors);
            setValidated(false);
            setIsLoading(false)
        } else {
            let data = {
                token: props.token,
                password: pass1,
            };
            API.password_change(data)
                .then((res) => {
                    setIsLoading(false);
                    setIsPassChanged(true);
                })
                .catch((err) => {
                    setIsLoading(false);
                    props.error(err.response.data.detail);
                });
        }
    };

    // Views
    return (
        isPassChanged === false ?
            <IconContentCard icon={<MdOutlineLockPerson size={80} className="text-light" />}>
                <p>
                    Geben Sie ein neues Passwort ein und clicken Sie auf Passwort
                    zurücksetzen
                </p>
                <Form validated={validated} onSubmit={(e) => passChangeHandler(e)}>
                    <Form.Group className="mb-3">
                        <FloatingLabel label="Passwort">
                            <Form.Control
                                isValid={VALIDATOR.PasswordValid(pass1)}
                                isInvalid={!!errors?.pass1}
                                type="password"
                                placeholder="Passwort"
                                value={pass1}
                                autoComplete="new-password"
                                onChange={(e) => setPass1(e.target.value)}
                            />
                        </FloatingLabel>
                        {errors?.pass1 ? (
                            <small className="text-danger">{errors.pass1}</small>
                        ) : null}
                    </Form.Group>
                    <Form.Group className="mt-3">
                        <FloatingLabel label="Passwort wiederholen">
                            <Form.Control
                                isValid={VALIDATOR.PasswordsEquals(pass1, pass2)}
                                isInvalid={!!errors?.pass2}
                                type="password"
                                placeholder="Passwort"
                                value={pass2}
                                onChange={(e) => setPass2(e.target.value)}
                            />
                        </FloatingLabel>
                        {errors?.pass2 ? (
                            <small className="text-danger">{errors.pass2}</small>
                        ) : null}
                    </Form.Group>
                    <Row className="mt-5">
                        <Col className="text-end">
                            {isLoading ?
                                <Spinner animation="border" className="text-energo" />
                                :
                                <Button type="submit" className="btn-energo">Password zurücksetzen</Button>
                            }
                        </Col>
                    </Row>
                </Form>
            </IconContentCard>
            :
            <IconContentCard icon={<MdDone size={80} className="text-white" />}>
                <h4 className="text-energo">Passwort geändert!</h4>
                <p className="mt-3">
                    Ihr Passwort wurde geändert.
                    Sie können sich jetzt mit Ihrem neuen
                    Passwort einloggen.
                </p>
                <div className="text-end mt-5">
                    <Button onClick={() => navigate('/')} className="btn-energo">Zurück zum Login</Button>
                </div>
            </IconContentCard>

    );
};

export default PassFormComponent;
